import(/* webpackMode: "eager" */ "/vercel/path0/app/privacy-policy/page.tsx");
